import { render } from "./TheSupplierDirectPaymentTypeBlocker.vue?vue&type=template&id=54047d7a&scoped=true"
import script from "./TheSupplierDirectPaymentTypeBlocker.vue?vue&type=script&lang=js"
export * from "./TheSupplierDirectPaymentTypeBlocker.vue?vue&type=script&lang=js"

import "./TheSupplierDirectPaymentTypeBlocker.vue?vue&type=style&index=0&id=54047d7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54047d7a"]])

export default __exports__